<template lang="pug">
  #signInIndex
    .container-width.p-3(v-if='detail')
      .cardImgArea
        img.w-100(:src="require('@/assets/images/card/default.png')")

      .infoArea.mx-4.mt-3
        p 會籍 : {{ shopDetail.VpTyNa }}
        p 會籍效期: {{ shopDetail.StDate }} - {{ shopDetail.EdDate }}
        p 續卡差額: {{ shopDetail.SumData21 }}
        p 消費紀錄 : (顯示近1年的消費紀錄)
        p 會籍期間一年內累積消費金額: {{ shopDetail.SumData11 }}
      .shoppingSheetArea.mx-4(v-if="tradeDetailClone && tradeDetailClone.length > 0")
        .detailArea.position-relative.mb-3(v-for="(detail, index) in tradeDetailClone")
          div.position-relative
            p.mb-1
              small {{ detail.Date }}  {{ detail.ShopName }}
            p.mb-1
              small 訂單 : {{ detail.EcrHdKey }}
            p.mb-1
              small 總額 : ${{ detail.Amount }}
            i.fas.fa-chevron-right.position-absolute(style='right: 0; top: 50%' v-if="!detail.show" @click='showDetail(index, true)')
            i.fas.fa-chevron-right.position-absolute(style='right: 0; top: 50%; transform: rotate(90deg)' v-else @click='showDetail(index, false)')
          div(style="background-color: #F0F0F0" v-show="detail.show")
            .py-3
              .productDetailArea.mx-1.py-1(v-for='(productDetail, index) in detail.TradeDetail')
                p.mb-1
                  .col-12.px-2
                    small {{ productDetail.GdsName }}
                .d-flex
                  .col-4.mb-1.px-1
                    small 容量 : {{ productDetail.GdsDesc ? productDetail.GdsDesc : '-' }}
                  .col-3.mb-1.px-1
                    small 數量 : {{ productDetail.Qty }}
                  .col-5.mb-1.px-1
                    small 金額 : ${{ productDetail.Amount }}

</template>

<script>
import { mapState } from 'vuex';
import { M_SIGN_UP_INDEX } from '@/router/member/sign-up';

export default {
  name: 'cardIndex',
  components: {
  },
  data() {
    return {
      detail: null,
      tradeDetailClone: []
    };
  },
  mounted() {
    const vm = this;
    // 檢查綁定狀態
    vm.$store.dispatch('member_sign_up/checkIsMemberHandler')
      .then((res) => {
        if (res.type === 'temp_binding') {
          vm.$store.commit('toggleLoading', false);
          vm.$swal.fire({
            icon: 'info',
            title: '您的資料已送出',
            html: '請前往官網註冊會員',
            confirmButtonText: '前往註冊'
          }).then(() => {
            window.location.href = process.env.VUE_APP_OFFICIAL_URL;
          });
        } else if (res.type === 'not_binding') {
          vm.$store.commit('toggleLoading', false);
          vm.$swal.fire({
            icon: 'info',
            title: '您尚未綁定'
          }).then(() => {
            vm.$router.push({
              name: M_SIGN_UP_INDEX
            });
          });
        } else {
          vm.$store.dispatch('member_card/getPosDataHandler', res.user.mobile).then(() => {
            vm.detail = _.cloneDeep(vm.shopDetail);
            vm.$store.commit('toggleLoading', false);
          });
          vm.$store.dispatch('member_card/getShopDetailHandler').then(() => {
            vm.tradeDetailClone = _.cloneDeep(vm.tradeDetail);
          });
        }
      });
  },
  methods: {
    showDetail(index, status) {
      const vm = this;
      vm.$set(vm.tradeDetailClone[index], 'show', status);
    }
  },
  computed: {
    ...mapState({
      shopDetail: (state) => state.member_card.shopDetail,
      tradeDetail: (state) => state.member_card.tradeDetail
    })
  }
};
</script>

<style scoped>
  .detailArea:not(:last-child) {
    border-bottom: 1px solid #000;
  }
  .productDetailArea:not(:last-child) {
    border-bottom: 1px solid #AEAEAE;
  }
</style>
